import AdvancedBookingOverviewComponent from "../components/booking-overview-advanced"

const AdvancedBookingOverview = (props) => {
    return <AdvancedBookingOverviewComponent type={props.type}></AdvancedBookingOverviewComponent>;
  };

  export default AdvancedBookingOverview;